import React from 'react'
import cn from 'classnames'
import { abbreviateNumber } from '@lib/utils'
import { StatBoxProps } from './interface'

function Typography({ label, total }: { label: string; total: number }) {
  return (
    <div className='px-[30px] text-center mobile:px-[14px]'>
      <p className='text-base font-bold'>{abbreviateNumber(total)}</p>
      <p className='text-secondary-1 font-light text-sm mt-[5px]'>{label}</p>
    </div>
  )
}

export default function StatBox({
  className,
  totalWriting,
  totalBookmark,
  totalReading,
}: StatBoxProps) {
  return (
    <div
      className={cn(
        'flex justify-center py-[15px] rounded-[8px] text-secondary dark:text-dark-10 h-fit mobile:py-0',
        className
      )}
    >
      <div className='w-fit grid grid-cols-3 divide-x divide-gray-3 dark:divide-purple mobile:w-full'>
        <Typography label='งานเขียน' total={totalWriting} />
        <Typography label='ถูกเก็บเข้าชั้น' total={totalBookmark} />
        <Typography label='ยอดวิว' total={totalReading} />
      </div>
    </div>
  )
}
